module.exports = __webpack_public_path__ + "static/media/11 Lapel Grip.e4ca424e.jpg";